<mat-dialog-actions [ngStyle]="styles">
	<ng-content></ng-content>
</mat-dialog-actions>
